import React from 'react';
import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = () => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <div style={{color: 'white', textAlign: 'center', paddingTop: '5rem'}}>Cargando...</div>;
  }

  // Si no hay usuario, lo redirige al login, pasando la ubicación original
  // a la que intentaba acceder en el 'state'.
  if (!user) {
    sessionStorage.setItem('post_login_redirect', location.pathname + location.search + location.hash);

    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Si hay usuario, renderiza el componente de la ruta solicitada.
  return <Outlet />;
};

export default ProtectedRoute;